module.exports = __webpack_public_path__ + "img/bg.b9100def.png";